import { Document } from './document';

export class DocumentPayload {
  public uid: number = 0;
  public accessToken: string = '';
  public documentName: string = '';
  public documentFile: any;
  public effectiveDate: any = '';
  public expiryDate: any = '';
  public document: Document = new Document();
  public documentId: number = 0;
  public licenseState: string = '';
  public licenseNumber: string = '';
}
